// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CounterpartyBankAccountType {
  Unspecified = "UNSPECIFIED",
  Domestic = "DOMESTIC",
  Iban = "IBAN",
  Foreign = "FOREIGN",
}
export default CounterpartyBankAccountType;
